"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OKXReporter = exports.OKXReportSide = exports.OKXReportType = exports.versionStr = void 0;
const cross_fetch_1 = __importDefault(require("cross-fetch"));
const log_1 = require("./log");
const url_1 = require("./url");
const utils_1 = require("../utils");
const localforage_1 = __importDefault(require("localforage"));
const tweetnacl_1 = __importDefault(require("tweetnacl"));
exports.versionStr = '1.5.5';
const reportApiList = [
    'https://www.okx.com/dappstat/wallet-connect',
    'https://www.okx.ac/dappstat/wallet-connect'
];
const reportCacheKey = 'OKX_RP_CK';
const reportUUIDKey = 'OKX_RP_UUID_CK';
const MAX_LIMIT_REPORTCOUNT = 100;
const DEFAULT_HTTP_HEADERS = {
    Accept: "*/*",
    "Content-Type": "text/plain",
};
const DEFAULT_HTTP_METHOD = "POST";
const DEFAULT_FETCH_OPTS = {
    headers: DEFAULT_HTTP_HEADERS,
    method: DEFAULT_HTTP_METHOD,
};
exports.OKXReportType = {
    PAGE_IN: 'page_in',
    PAGE_OUT: 'page_out',
    CLICK: 'click',
    LOG: 'log',
};
exports.OKXReportSide = {
    DAPP: 'dapp',
    WALLET: 'wallet',
};
class IReporter {
}
const fetchWithTimeout = (url, options, timeout = 5000) => {
    const controller = new AbortController();
    const signal = controller.signal;
    const fetchPromise = (0, cross_fetch_1.default)(url, Object.assign(Object.assign({}, options), { signal }));
    const timeoutPromise = new Promise((_, reject) => setTimeout(() => {
        controller.abort();
        reject(new Error('Request timed out'));
    }, timeout));
    return Promise.race([fetchPromise, timeoutPromise]);
};
const fetchListWithTimeout = (urls_1, ...args_1) => __awaiter(void 0, [urls_1, ...args_1], void 0, function* (urls, options = {}, timeout = 5000) {
    for (const url of urls) {
        try {
            const controller = new AbortController();
            const signal = controller.signal;
            const fetchPromise = (0, cross_fetch_1.default)(url, Object.assign(Object.assign({}, options), { signal }));
            const timeoutPromise = new Promise((_, reject) => setTimeout(() => {
                controller.abort();
                reject(new Error('Request timed out'));
            }, timeout));
            const response = yield Promise.race([fetchPromise, timeoutPromise]);
            if (response.ok) {
                return response;
            }
            if (response.status == 502) {
                console.error(`Fetch error status 502`, url);
                return response;
            }
        }
        catch (error) {
            console.error(`Fetch error for ${url}:`, error);
        }
    }
    console.error(`'All fetch attempts failed.'`);
    throw new Error('All fetch attempts failed.');
});
class OKXReporter {
    constructor() {
        this.currentSide = exports.OKXReportSide.DAPP;
        this.currentVersion = exports.versionStr;
        this.storage = localforage_1.default.createInstance({
            name: "OKXReporter"
        });
        this.recordList = new Array();
        this.currentUUID = (0, utils_1.toHexString)(tweetnacl_1.default.randomBytes(16));
    }
    configVersionAndSide(version, side, appname) {
        this.currentVersion = version;
        this.currentSide = side;
        this.appName = appname;
    }
    get recordCacheKey() {
        return reportCacheKey + "@" + this.appName;
    }
    get reportPlatform() {
        if ((0, utils_1.isMobileUserAgent)()) {
            if ((0, utils_1.isIos)()) {
                return 'iOS';
            }
            else {
                return 'android';
            }
        }
        else {
            return 'pc';
        }
    }
    beginReport() {
        return __awaiter(this, void 0, void 0, function* () {
            this.startErrorCatching();
            let records = yield this.storage.getItem(this.recordCacheKey);
            let uuid = yield this.storage.getItem(reportUUIDKey);
            if (uuid) {
                this.currentUUID = uuid;
            }
            else {
                this.storage.setItem(reportUUIDKey, this.currentUUID);
            }
            if (records) {
                this.recordList = records;
                (0, log_1.logDebug)('resume records from cache length: ', this.recordList.length);
                yield this.sendCachedRecords();
            }
        });
    }
    startErrorCatching() {
        let window = (0, url_1.getWindow)();
        if (window) {
            (0, log_1.logDebug)('begin capture console error');
            // window.onerror = (event: Event | string, source?: string, lineno?: number, colno?: number, error?: Error) => {
            //     logDebug('capture error info:', error, source)
            //     this.markRecord(error?.message+'/'+error?.name+'/'+error?.stack, OKXReportType.LOG, '', this.currentSide)
            // }
        }
    }
    cachedErrors() {
        return this.recordList;
    }
    sendRecord(record) {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                try {
                    const body = JSON.stringify(record);
                    (0, log_1.logDebug)('[REPORT] record: ', body);
                    const res = yield fetchListWithTimeout(reportApiList, Object.assign(Object.assign({}, DEFAULT_FETCH_OPTS), { body: body }));
                    (0, log_1.logDebug)('[REPORT] get rsp:', res);
                    if (res && res.status && res.status == 200) {
                        this.recordList = this.recordList.filter((item) => {
                            return item.timestamp != record.timestamp || item.content != record.content;
                        });
                        yield this.storage.setItem(this.recordCacheKey, this.recordList);
                        resolve(true);
                    }
                    else {
                        reject(false);
                    }
                }
                catch (e) {
                    (0, log_1.logDebug)('send record error:', e);
                    resolve(true);
                    // reject(e)
                }
            }));
        });
    }
    sendRecordContent(content, type, action) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d;
            let path = (_a = (0, url_1.getWindow)()) === null || _a === void 0 ? void 0 : _a.location.pathname;
            let location = (_b = (0, url_1.getWindow)()) === null || _b === void 0 ? void 0 : _b.location.origin;
            if (path && location) {
                location = location + path;
            }
            let language = (_c = (0, url_1.getWindow)()) === null || _c === void 0 ? void 0 : _c.navigator.language;
            let ua = (_d = (0, url_1.getWindow)()) === null || _d === void 0 ? void 0 : _d.navigator.userAgent;
            let platform = this.reportPlatform;
            let reportItem = {
                uuid: this.currentUUID,
                version: this.currentVersion,
                content: content,
                action: action,
                side: this.currentSide,
                timestamp: new Date().getTime(),
                url: location,
                lang: language,
                type: type,
                platform: platform,
                "user-agent": ua
            };
            yield this.markRecordItem(reportItem);
            yield this.sendRecord(reportItem);
        });
    }
    sendCachedRecords() {
        return __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                let sendList = this.recordList.map(record => this.sendRecord(record));
                (0, log_1.logDebug)('[REPORT] submit & clean recorded caches begin @', new Date().toUTCString());
                Promise.allSettled(sendList).then((results) => {
                    (0, log_1.logDebug)('[REPORT] submit & clean recorded caches ends @', new Date().toUTCString());
                    let keepIndex = [];
                    results.forEach((result, index) => {
                        if (result.status == "rejected") {
                            keepIndex.push(index);
                        }
                    });
                    this.recordList = this.recordList.filter((_, index) => !keepIndex.includes(index));
                    this.storage.setItem(this.recordCacheKey, this.recordList).then(function (value) {
                        resolve();
                    }).catch(function (err) {
                        reject(err);
                    });
                });
            }));
        });
    }
    markRecordItem(item) {
        return __awaiter(this, void 0, void 0, function* () {
            this.recordList.push(item);
            if (this.recordList.length > MAX_LIMIT_REPORTCOUNT) {
                let offset = this.recordList.length - MAX_LIMIT_REPORTCOUNT;
                this.recordList.splice(0, offset);
            }
            return new Promise((resolve, reject) => {
                this.storage.setItem(this.recordCacheKey, this.recordList).then(function (value) {
                    resolve(item);
                }).catch(function (err) {
                    reject(err);
                });
            });
        });
    }
    markRecord(content, type, action, side) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c, _d;
            let path = (_a = (0, url_1.getWindow)()) === null || _a === void 0 ? void 0 : _a.location.pathname;
            let location = (_b = (0, url_1.getWindow)()) === null || _b === void 0 ? void 0 : _b.location.origin;
            if (path && location) {
                location = location + path;
            }
            let language = (_c = (0, url_1.getWindow)()) === null || _c === void 0 ? void 0 : _c.navigator.language;
            let platform = this.reportPlatform;
            let ua = (_d = (0, url_1.getWindow)()) === null || _d === void 0 ? void 0 : _d.navigator.userAgent;
            let reportItem = {
                uuid: this.currentUUID,
                version: this.currentVersion,
                content: content,
                action: action,
                side: side,
                timestamp: new Date().getTime(),
                url: location,
                lang: language,
                type: type,
                platform: platform,
                "user-agent": ua
            };
            return yield this.markRecordItem(reportItem);
        });
    }
}
exports.OKXReporter = OKXReporter;
